module.exports = __webpack_public_path__ + "5f07736b919ec306f9792f3206d6bdb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/cta/icon_testdrive_light.png
// module id = 726
// module chunks = 0 1